export default function DashboardIcon({ color = "#FAFAFA" }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.0000 3.0000H4.0000C3.4477 3.0000 3.0000 3.4477 3.0000 4.0000V11.0000C3.0000 11.5523 3.4477 12.0000 4.0000 12.0000H9.0000C9.5523 12.0000 10.0000 11.5523 10.0000 11.0000V4.0000C10.0000 3.4477 9.5523 3.0000 9.0000 3.0000Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        strokeWidth={"1.5"}
      />
      <path
        d="M19.9999 3.0000H15.0000C14.4477 3.0000 14.0000 3.4477 14.0000 4.0000V7.0000C14.0000 7.5523 14.4477 8.0000 15.0000 8.0000H19.9999C20.5523 8.0000 21.0000 7.5523 21.0000 7.0000V4.0000C21.0000 3.4477 20.5523 3.0000 19.9999 3.0000Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        strokeWidth={"1.5"}
      />
      <path
        d="M19.9999 12.0000H15.0000C14.4477 12.0000 14.0000 12.4477 14.0000 13.0000V19.9999C14.0000 20.5523 14.4477 21.0000 15.0000 21.0000H19.9999C20.5523 21.0000 21.0000 20.5523 21.0000 19.9999V13.0000C21.0000 12.4477 20.5523 12.0000 19.9999 12.0000Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        strokeWidth={"1.5"}
      />
      <path
        d="M9.0000 16.0001H4.0000C3.4477 16.0001 3.0000 16.4476 3.0000 16.9999V19.9999C3.0000 20.5523 3.4477 21.0000 4.0000 21.0000H9.0000C9.5523 21.0000 10.0000 20.5523 10.0000 19.9999V16.9999C10.0000 16.4476 9.5523 16.0001 9.0000 16.0001Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        strokeWidth={"1.5"}
      />
    </svg>
  );
}
